import { lazy } from 'react';

export const AdministrationPage = lazy(() => import('./AdministrationPage'));
